import React from "react"
import { concatStrings, uniqueId } from "../utilities"

const DfbToggle = props => {
  const inputId = uniqueId(`${props.idPrefix}-`)
  const value = props.value ? { value: props.value } : {}
  const ariaLabel = props.ariaLabel ? { "aria-label": props.ariaLabel } : {}
  const required = props.required ? { required: true } : {}
  const disabled = props.disabled ? { disabled: true } : {}
  const style = props.add_style ? { style: props.add_style} : {}

  return (
    <div className={concatStrings("dfb-Toggle", props.add_class)}{...style}>
      <label className="dfb-Toggle-field">
        <span className="dfb-Toggle-labelUnchecked">
          {props.labelUnchecked}
        </span>
        <input
          className="dfb-Toggle-input"
          type="checkbox"
          name={props.name}
          id={inputId}
          checked={props.checked}
          onChange={props.onChange}
          {...value}
          {...ariaLabel}
          {...required}
          {...disabled}
        />
        <span className="dfb-Toggle-box" aria-hidden="true" />
        <span className="dfb-Toggle-labelChecked">{props.labelChecked}</span>
      </label>
    </div>
  )
}
DfbToggle.defaultProps = {
  idPrefix: "toggle-",
  value: "true",
  name: "Toggle",
  required: false,
  disabled: false,
  checked: false,
  labelChecked: "On",
  labelUnchecked: "Off",
}
export default DfbToggle
